<template>
  <div class="chat-list-wrapper d-flex flex-column fill-height">
    <!-- Header -->
    <div class="chat-header text-center py-4 px-4">
      <BaseSkeleton
        type="text"
        width="100px"
      />
    </div>

    <!-- Grouped Chat Skeletons -->
    <div class="chat-list-scroll flex-grow-1 overflow-y-auto px-2">
      <v-list density="compact">
        <div
          v-for="group in 3"
          :key="'group-' + group"
        >
          <BaseSkeleton
            type="text"
            width="80px"
            class="mb-2"
          />

          <div
            v-for="i in 3"
            :key="'item-' + group + '-' + i"
            class="mb-2"
          >
            <BaseSkeleton type="list-item" />
          </div>

          <v-divider class="my-3" />
        </div>
      </v-list>
    </div>

    <!-- Footer -->
    <div class="chat-footer px-4 py-4">
      <v-divider class="mb-3" />
      <BaseSkeleton
        type="button"
        width="100%"
        height="36px"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseSkeleton from '@/interfaces/components/skeletons/BaseSkeleton.vue';
</script>

<style scoped lang="sass">
  .chat-list-wrapper
    height: 100%
    display: flex
    flex-direction: column

  .chat-header
    flex-shrink: 0

  .chat-list-scroll
    flex-grow: 1
    overflow-y: auto
    min-height: 0

  .chat-footer
    flex-shrink: 0
    background-color: white
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.04)
    z-index: 1
</style>
